












































































import { addBasePath } from '~/helpers/addBasePath';
import {
  computed, defineComponent, ref, useContext, useFetch, watch,
} from '@nuxtjs/composition-api';
import { SfImage } from '~/components/StorefrontUi';
import { SHOP_TITLE } from '~/config/base';
import useStoryblokView from '~/modules/storyblok/composables/useStoryblokView';

export default defineComponent({
  name: 'StaticLinks',
  components: {
    SfImage,
  },
  setup() {
    const { app } = useContext();
    const lang = computed(() => app.i18n.locale);
    const { getStoryBySlug } = useStoryblokView();
    const navItems = ref([]);
    const rightLinks = ref([]);

    const { fetch } = useFetch(async () => {
      const { story } = await getStoryBySlug({
        slug: 'general/header',
        redirectOnError: true,
      });

      if (story) {
        navItems.value = story.content.links;
        rightLinks.value = story.content.rightLink;
      }
    });

    fetch();

    watch(() => lang.value, () => {
      fetch();
    });

    return {
      addBasePath,
      SHOP_TITLE,
      navItems,
      rightLinks,
    };
  },
});
